export default function IcUser() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99935 18.3334C14.6017 18.3334 18.3327 14.6025 18.3327 10.0001C18.3327 5.39771 14.6017 1.66675 9.99935 1.66675C5.39698 1.66675 1.66602 5.39771 1.66602 10.0001C1.66602 14.6025 5.39698 18.3334 9.99935 18.3334Z"
        fill="white"
      />
      <path
        d="M14.7834 15.2166C13.5251 16.3749 11.8418 17.0833 10.0001 17.0833C8.15846 17.0833 6.47513 16.3749 5.2168 15.2166C5.58346 14.0666 6.53349 12.9749 8.57515 12.9749H11.4251C13.4584 12.9749 14.4084 14.0749 14.7834 15.2166ZM12.5068 8.33325C12.5068 6.95242 11.3877 5.83325 10.0068 5.83325C8.626 5.83325 7.50684 6.95242 7.50684 8.33325C7.50684 9.71409 8.626 10.8333 10.0068 10.8333C11.3877 10.8333 12.5068 9.71409 12.5068 8.33325Z"
        fill="black"
      />
    </svg>
  );
}
